import Base from "./Base";

class MailMerge extends Base {
    static getMailAccounts(body) {
        return this.sendRequest("/api/mail-campaign/get-mail-accounts", "POST", {}, body);
    }
    static getTemplates(body) {
        return this.sendRequest("/api/mail-campaign/get-templates", "POST", {}, body);
    }
    static getTimezones(body) {
        return this.sendRequest("/api/mail-campaign/get-timezones", "POST", {}, body);
    }
    static preview(body) {
        return this.sendRequest("/api/mail-campaign/preview", "POST", {}, body);
    }
    static create(body) {
        return this.sendRequest("/api/mail-campaign/create", "POST", {}, body);
    }
    static deleteAccount(body) {
        return this.sendRequest("/api/mail-campaign/delete-account", "POST", {}, body);
    }
    static reconnectAccount(body) {
        return this.sendRequest("/api/mail-campaign/reconnect-account", "POST", {}, body);
    }
    static disconnectAccount(body) {
        return this.sendRequest("/api/mail-campaign/disconnect-account", "POST", {}, body);
    }
    static deleteTemplate(body) {
        return this.sendRequest("/api/mail-campaign/delete-template", "POST", {}, body);
    }
    static validateAccount(body) {
        return this.sendRequest("/api/mail-campaign/validate-account", "POST", {}, body);
    }
    static setAccountPermissions(body) {
        return this.sendRequest("/api/mail-campaign/set-account-permissions", "POST", {}, body);
    }
    static addSmptAccount(body) {
        return this.sendRequest("/api/mail-campaign/add-smtp-account", "POST", {}, body);
    }
}

export default MailMerge; 